module.exports = __webpack_public_path__ + "static/media/cog.bd03e9fa.png";